import { render } from "./BasePageHeading.vue?vue&type=template&id=591d7ef0"
import script from "./BasePageHeading.vue?vue&type=script&lang=js"
export * from "./BasePageHeading.vue?vue&type=script&lang=js"

import exportComponent from "/home/circleci/app-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__